import styled from 'styled-components'

const EntityExampleWrapperUi = styled.div`
  position: relative;
  font-family: var(--font-family);
`
export default EntityExampleWrapperUi
